import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Icon from '@omilia/icon';
import styled from 'styled-components';

import termOptions from 'constants/termOptions';
import Search from 'components/Search';
import Button from 'components/Button';
import ImportExportDropdown from 'components/ImportExportDropdown';

const STrainButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  &&& {
    min-width: unset;
    padding: 3px 8px;
  }
`;

const ListHeaderTopRightOptions = ({
  items,
  modelName,
  onMergeImport,
  onReplaceImport,
  onExport,
  openNewModal,
  searchTerm,
  getItems,
  displayTrainButton,
  onTrain,
}) => {
  const termOption = termOptions[modelName];

  const handleGetItems = useCallback(
    searchTerm => {
      getItems({
        page: 1,
        name__icontains: searchTerm,
        ordering: 'name',
      });
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [],
  );

  return (
    <React.Fragment>
      <Search
        getItems={handleGetItems}
        itemsCount={items.length}
        placeholder={termOption.search}
        searchTerm={searchTerm}
      />

      {displayTrainButton && (
        <STrainButton
          isOutlined
          isSmall
          data-test="train-button"
          type="button"
          onClick={onTrain}
        >
          <Icon glyph="ml-training" size="21" />
          <span>Train</span>
        </STrainButton>
      )}

      <Button
        isSmall
        data-test="create-button"
        type="button"
        onClick={openNewModal}
      >
        {termOption.create}
      </Button>

      {onExport && (
        <ImportExportDropdown
          modelName={termOption.title}
          onExport={onExport}
          onMergeImport={onMergeImport}
          onReplaceImport={onReplaceImport}
        />
      )}
    </React.Fragment>
  );
};

ListHeaderTopRightOptions.propTypes = {
  displayTrainButton: PropTypes.bool.isRequired,
  getItems: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  modelName: PropTypes.string.isRequired,
  openNewModal: PropTypes.func.isRequired,
  onTrain: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  onExport: PropTypes.func,
  onMergeImport: PropTypes.func,
  onReplaceImport: PropTypes.func,
};

export default memo(ListHeaderTopRightOptions);
